/* global axios */
import ApiClient from './ApiClient';

class TeamExportsAPI extends ApiClient {
  constructor() {
    super('team_exports', { accountScoped: true, apiVersion: 'v2' });
  }

  download({ teamId, kind, since, until }) {
    return axios.get(`${this.url}/${teamId}/${kind}`, {
      params: {
        since,
        until,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      responseType: 'blob',
    });
  }
}

export default new TeamExportsAPI();
